import React from 'react';
import withProfileFieldData from 'apps/journey/hoc/with-profile-field-data';
import Markdown from 'library/helpers/markdown';
import { string } from 'prop-types';

const ProfileLinkType = ({ question: { text } }) => {
  return <div dangerouslySetInnerHTML={{ __html: Markdown.render(text) }} />;
};

ProfileLinkType.propTypes = {
  question: {
    text: string,
  },
};

export default withProfileFieldData(ProfileLinkType);
